// Service Worker ko unregister aur cache clear karne ka utility function

export const unregisterServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      
      // Clear cache first
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames.map((cacheName) => {
            console.log('Clearing cache:', cacheName);
            return caches.delete(cacheName);
          })
        );
      }
      
      // Send message to service worker to clear cache
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: 'CLEAR_CACHE'
        });
      }
      
      // Unregister all service workers
      await Promise.all(
        registrations.map((registration) => {
          console.log('Unregistering service worker');
          return registration.unregister();
        })
      );
      
      console.log('Service Worker and cache cleared successfully');
      return true;
    } catch (error) {
      console.error('Error clearing service worker:', error);
      return false;
    }
  }
  return false;
};

export const clearAppCache = async () => {
  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames.map((cacheName) => caches.delete(cacheName))
      );
      console.log('App cache cleared');
      return true;
    } catch (error) {
      console.error('Error clearing cache:', error);
      return false;
    }
  }
  return false;
};